export type SpeciesKey = "sheep";

export type SpeciesLabels = {
  animal_singular: string;
  animal_plural: string;
  dam: string;
  sire: string;
  offspring: string;
  breeding_season: string;
  birth_season: string;
  lookup_title: string;
  lookup_heading: string;
};

export type SpeciesDefinition = {
  key: SpeciesKey;
  labels: SpeciesLabels;
};

const SPECIES: Record<SpeciesKey, SpeciesDefinition> = {
  sheep: {
    key: "sheep",
    labels: {
      animal_singular: "owca",
      animal_plural: "owce",
      dam: "owca",
      sire: "tryk",
      offspring: "jagnię",
      breeding_season: "stanówka",
      birth_season: "wykot",
      lookup_title: "Szukaj owcy",
      lookup_heading: "Owca",
    },
  },
};

export const DEFAULT_SPECIES: SpeciesKey = "sheep";

export function getSpecies(species: SpeciesKey): SpeciesDefinition {
  return SPECIES[species];
}
